import React from 'react';
import JoinGroupButton from '../joinGroupButton';
import { HeroActionButton, HeroActions, HeroCard, HeroInfo, HeroMeta, HeroTitle } from '../index.styled';
import { PlusOutlined } from '@ant-design/icons';

interface GroupHeroProps {
  name?: string;
  coverPhotoUrl?: string;
  location: string;
  memberCount: number;
  groupId?: string;
  showJoinGroupButton?: boolean;
  showManageButtons?: boolean;
  onEdit: () => void;
  onManage: () => void;
  onCreateEvent?: () => void;
}

const GroupHero = ({
  name,
  coverPhotoUrl,
  location,
  memberCount,
  groupId,
  showJoinGroupButton = false,
  showManageButtons = false,
  onEdit,
  onManage,
  onCreateEvent,
}: GroupHeroProps) => {
  return (
    <>
      <HeroCard coverPhotoUrl={coverPhotoUrl || ''}>
        <HeroInfo>
          <HeroTitle>{name || 'Group'}</HeroTitle>
          <HeroMeta>
            <span>
              <i className="icon-pin" /> {location}
            </span>
            <span>
              <i className="icon-user" /> {memberCount} members
            </span>
          </HeroMeta>
        </HeroInfo>
        <HeroActions>
          {showManageButtons && (
            <>
              <HeroActionButton disabled={!groupId} onClick={onEdit}>
                Edit
              </HeroActionButton>
              {onCreateEvent ? (
                <HeroActionButton disabled={!groupId} onClick={onCreateEvent}>
                  <PlusOutlined />
                  Create Event
                </HeroActionButton>
              ) : null}
              {/* <HeroActionButton disabled={!groupId} onClick={onManage}>
                Manage Group
              </HeroActionButton> */}
            </>
          )}
          {showJoinGroupButton && !!groupId && <JoinGroupButton groupId={groupId} />}
        </HeroActions>
      </HeroCard>
    </>
  );
};

export default GroupHero;
